import React, { useState, useEffect } from 'react';
import s from "./Header.module.css"
import { useUser } from '../../Context/UserContext';
import { logoutUser } from '../../Api//AuthApi';
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from '../../hooks/mobileHook';
import {Sidebar} from './Sidebar';
import { fetchLabel } from '../../Api//LabelApi'

export function Header() {
    const isMobile = useIsMobile();
    const { user, setUser } = useUser();
    const navigate = useNavigate();
    const [activeSideBar, setActiveSideBar] = useState(true)
    const [activeComponent, setActiveComponent] = useState('Devices');
    const [data, setData] = useState(null)

    useEffect(() => {
        const fetchData = async () => {
            try {
                const json_data = await fetchLabel();
                setData(json_data);
            } catch (error) {
                console.error('Failed to fetch data:', error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (isMobile) {
            setActiveSideBar(false);
        }
    }, [isMobile]);

    const handleLogout = async () => {
        try {
            await logoutUser();
        } catch (error) {
            console.error("Logout error:", error);
        }
        setUser(null);
        localStorage.removeItem('user');
        navigate("/login");
    };


    const handleMenuToggle = () => {
        setActiveSideBar(prevState => !prevState);
    };

    return (
        <div className={s.header}>
            {!isMobile ? (
                <div className={s.logo}></div>
            ) : (
                <>
                    <div className={s.mobileMenu} onClick={handleMenuToggle}>
                        <img src={'/menu.svg'}></img>
                    </div>
                    <div className={s.logo}></div>
                    <div className={s.mobileUser}>
                        <img src={'/user.svg'}></img>
                    </div>
                    {activeSideBar ? (
                        <Sidebar setActiveSideBar={setActiveSideBar} setActiveComponent={setActiveComponent} handleMenuToggle={handleMenuToggle} />
                    ) : (
                        <></>
                    )}
                </>
            )
            }

            {!isMobile ? (<>
                <div className={s.label}>
                    <div className={s.grid1}>
                        <span>всего устройств</span>
                        <div className={s.gridItem1}>
                            <span>{data?.totalRows}</span>
                        </div>
                    </div>
                    <div className={s.grid2}>
                        <span>в сети</span>
                        <div className={s.gridItem2}>
                            <span>{data?.onlineRows}</span>
                        </div>
                    </div>
                    <div className={s.grid3}>
                        <span>с ошибками</span>
                        <div className={s.gridItem3}>
                            <span>{data?.problemRows}</span>
                        </div>
                    </div>
                    <div className={s.grid4}>
                        <span>не в сети</span>
                        <div className={s.gridItem4}>
                            <span>{data?.warnRows}</span>
                        </div>
                    </div>
                </div>
                <div className={s.user}>
                    <span>{user?.email}</span>
                    <div className={s.userIcon} onClick={handleLogout}>
                        <img src={'/logout.svg'}></img>
                    </div>
                </div>
            </>
            ) : (<></>)
            }
        </div>
    )
}

